var storage_session;
var fail;
var uid;
try {
  uid = new Date;
  (storage_session = window.sessionStorage).setItem(uid, uid);
  fail = storage_session.getItem(uid) != uid;
  storage_session.removeItem(uid);
  fail && (storage_session = false);
} catch (exception) {}

function setStorage(storage, key, struct) {
  var data = getStorage(storage)
  if (!data) {
    data = {}
  }
  data[key] = struct
  // Store the value
  storage_session.setItem(storage, JSON.stringify(data))
}

function getStorage(storage, key) {
  var structRaw = storage_session.getItem(storage)

  if (structRaw && structRaw.length) {
    // We have data
    var struct = JSON.parse(structRaw)
    return key ? struct[key] : struct
  } else {
    return null
  }
}

function clearStorage(storage, key) {
  if (storage) {
    var struct = getStorage(storage)
    if (struct) {
      // We have data
      if (struct[key]) {
        delete struct[key]
        // Update the storage with the missing itme
        if (Object.keys(struct).length === 0) {
          storage_session.removeItem(storage);
        } else {
          // Store struct with the key removed
          storage_session.setItem(storage, JSON.stringify(struct))
        }
      }
    }
  } else {
    storage_session.clear()
  }
}

exports.hasStorage = function() { return !fail }
exports.setStorage = setStorage
exports.clearStorage = clearStorage
exports.getStorage = getStorage


